import React from 'react'
import medicaidIcon from './icons/medicaid.svg'
import acceptsHealthInsIcon from './icons/accepts_health_insurance.svg'
import isFreeIcon from '../../../assets/images/clinics/features/is_low_cost.svg'
import slidingScaleIcon from './icons/sliding_scale.svg'
import acceptsUninsuredIcon from '../../../assets/images/clinics/features/accepts_uninsured.svg'
import financialAssistanceIcon from '../../../assets/images/clinics/features/abortion_financial_assistance_available.svg'
import './PaymentOptions.scss'

const PaymentOptions = ({
  privateInsurance,
  publicInsurance,
  isFree,
  isFreeStr,
  slidingScale,
  slidingScaleStr,
  acceptsUninsured,
  uninsuredStr,
  financialAssistanceAvailable,
  financialAssistanceAvailableStr,
  paymentOptionsTitle,
  someIns,
  medicaidStr,
  privateAcc,
}) => {
  return (
    <div className="payment-options-container">
      <div className="payment-options">
        <h3>{paymentOptionsTitle}</h3>
        {!(privateInsurance || publicInsurance) && (
          <div className="insurance">{someIns}</div>
        )}
        {publicInsurance && (
          <div className="insurance">
            <img src={medicaidIcon} alt="public insurance" />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: medicaidStr }} />
          </div>
        )}
        {privateInsurance && (
          <div className="insurance">
            <img src={acceptsHealthInsIcon} alt="private insurance" />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: privateAcc }} />
          </div>
        )}
        {isFree && (
          <div className="insurance">
            <img src={isFreeIcon} alt="free" />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: isFreeStr }} />
          </div>
        )}
        {slidingScale && (
          <div className="insurance">
            <img src={slidingScaleIcon} alt="sliding scale" />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: slidingScaleStr }} />
          </div>
        )}
        {acceptsUninsured && (
          <div className="insurance">
            <img src={acceptsUninsuredIcon} alt="accepts uninsured" />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: uninsuredStr }} />
          </div>
        )}
        {!(isFree || slidingScale) && financialAssistanceAvailable && (
          <div className="insurance">
            <img src={financialAssistanceIcon} alt="financial assistance" />
            {/* eslint-disable-next-line react/no-danger */}
            <span
              dangerouslySetInnerHTML={{
                __html: financialAssistanceAvailableStr,
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PaymentOptions
